export default IconBoxPadding => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-box-padding" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
  <path d="M8 16v.01" />
  <path d="M8 12v.01" />
  <path d="M8 8v.01" />
  <path d="M16 16v.01" />
  <path d="M16 12v.01" />
  <path d="M16 8v.01" />
  <path d="M12 8v.01" />
  <path d="M12 16v.01" />
</svg>`;